import React from 'react';
import classNames from 'classnames';
import { map, prop } from 'ramda';

// En-têtes de colonnes : une cellule par formule (NOM_FORMULE_BASE).
// La 1re cellule reste vide : elle accueillera la Part employeur (hors ticket).
const FormulaHeader = ({ displayedPricings, isSelected }) => (
  <div
    className={'grid'}
    style={{
      gridTemplateColumns: `300px repeat(${displayedPricings.length}, minmax(150px, 1fr))`
    }}
  >
    <div className={'flex flex-col w-full gap-4 mt-8 sticky left-0 bg-white z-10'} />
    {map((pricing) => {
      const pricingLabel = prop('pricingLabel', pricing);

      return (
        <div
          key={pricingLabel}
          className={'relative flex flex-col items-center mt-8 mx-1 border-t border-l border-r rounded-t-xl'}
        >
          <div
            className={classNames('text-center border-t border-l border-r rounded-t-xl w-full', {
              'border-primary bg-primary text-white': isSelected(pricingLabel),
              'bg-primary text-white': !isSelected(pricingLabel)
            })}
          >
            <div className={'font-semibold p-2 text-xl flex gap-2 justify-center'}>
              {pricingLabel}
            </div>
          </div>
        </div>
      );
    }, displayedPricings)}
  </div>
);

export default FormulaHeader;
